import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';

export const AppBarWrapper = styled(AppBar)(({ theme }) => ({
  height: 72,
  justifyContent: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
